import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames/bind';

import Styles from './FeatureList.styles';

const context = classNames.bind(Styles);

export const FeatureList = ({ children, isColumn, marginless }) => (
  <ul className={context('feature-list', { 'feature-list-column': isColumn, marginless })}>{children}</ul>
);

FeatureList.propTypes = {
  children: propTypes.node.isRequired, isColumn: propTypes.bool, marginless: propTypes.bool,
};

FeatureList.defaultProps = {
  isColumn: false,
  marginless: false,
};

FeatureList.Header = ({ children }) => (
  <div className={`${Styles['feature-header']} text-gray-600`}>{children}</div>
);

FeatureList.Header.propTypes = { children: propTypes.node.isRequired };
